import { memo } from 'react'
import { ToastContainer } from 'react-toastify'

import { FullPageLoader } from './ui'

const Component = memo(({ comp }) => (
  <>
    <FullPageLoader />
    <ToastContainer
      position="bottom-right"
      autoClose={4000}
      hideProgressBar={false}
      // newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      style={{ zIndex: 9999999 }}
    />
    {comp}
  </>
))

const Wrapper = (WrappedComp) => <Component comp={<WrappedComp />} />

export const withLoader = (component) => () => Wrapper(component)
